import React from "react";
import { LogoutOutlined, UserOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Menu, Space } from "antd";

const HeaderAdmin = () => {
  const Cookies = require("js-cookie");

  const handleLogout = () => {
    Cookies.remove("access_token");
    window.location.reload();
  };

  const menu = (
    <Menu
      items={[
        {
          key: "logout",
          label: (
            <span onClick={handleLogout} style={{ color: "#ff4d4f", fontWeight: 700 }}>
              Đăng xuất
            </span>
          ),
          icon: <LogoutOutlined style={{ color: "#ff4d4f" }} />,
        },
      ]}
    />
  );

  return (
    <header className="admin-header">
      <div className="admin-header__brand">
        <div className="admin-header__logo-icon">
          <SafetyCertificateOutlined />
        </div>
        <div className="admin-header__title">LLWIN Admin Hub</div>
      </div>

      <div className="flex items-center gap-3">
        <Dropdown overlay={menu} trigger={["hover"]}>
          <div className="admin-header__user-pill">
            <Avatar className="admin-header__avatar" icon={<UserOutlined />} size="small" />
            <span style={{ fontSize: 13, fontWeight: 700, color: "#ffffff" }}>QUẢN TRỊ VIÊN</span>
          </div>
        </Dropdown>
      </div>
    </header>
  );
};

export default HeaderAdmin;
